export const formatMoneyBRL = (value) => {
  return parseFloat(value).toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    style: 'currency',
    currency: 'BRL',
  })
}

export const BRLMoneyToNumber = (value: string) =>
  value ? Number(value.split('R$ ')[1].replace(/\./g, '').replace(',', '.')) : 0
